import { Eye, EyeOff } from "lucide-react";
import { useTranslation } from "react-i18next";
import { stringToColor } from "@/shared/utils/color/string-to-color";

interface PolygonLegendProps {
  selectedPolygons: { id: number; name: string }[];
  hiddenPolygonIds: Set<number>;
  onToggleVisibility: (id: number) => void;
}

const PolygonLegend: React.FC<PolygonLegendProps> = ({
  selectedPolygons,
  hiddenPolygonIds,
  onToggleVisibility,
}) => {
  const { t } = useTranslation("polygon");

  if (selectedPolygons.length === 0) return null;

  return (
    <div className="bg-background border border-border rounded-md shadow-md px-3 py-2">
      <span className="text-xs font-medium text-muted-foreground mb-1.5 block">
        {t("legend.title")}
      </span>
      <div className="flex flex-col gap-1">
        {selectedPolygons.map((polygon) => {
          const isHidden = hiddenPolygonIds.has(polygon.id);
          return (
            <div
              key={polygon.id}
              className="flex items-center gap-2 text-sm"
            >
              <div
                className="h-3 w-3 rounded-full shrink-0 border border-border"
                style={{
                  backgroundColor: stringToColor(polygon.name),
                  opacity: isHidden ? 0.4 : 1,
                }}
              />
              <span
                className={`truncate flex-1 ${isHidden ? "text-muted-foreground line-through" : ""}`}
              >
                {polygon.name}
              </span>
              <button
                onClick={() => onToggleVisibility(polygon.id)}
                className="shrink-0 p-0.5 rounded hover:bg-accent transition-colors text-muted-foreground hover:text-foreground"
                title={isHidden ? t("legend.show") : t("legend.hide")}
              >
                {isHidden ? (
                  <EyeOff className="h-3.5 w-3.5" />
                ) : (
                  <Eye className="h-3.5 w-3.5" />
                )}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PolygonLegend;
